<template>
  <v-select
    v-model="selected"
    :items="entities"
    hide-no-data
    :label="useHolder ? null : $t('entity')"
    :placeholder="useHolder ? $t('entity') : null"
    required
    :error-messages="errors"
  >
    <template slot="selection" slot-scope="{ selected, item }">
      <v-list-item-content>{{ $t(`labels.${item}`) }}</v-list-item-content>
    </template>

    <template slot="item" slot-scope="{ item }">
      <v-list-item-content>{{ $t(`labels.${item}`) }}</v-list-item-content>
    </template>
  </v-select>
</template>

<script>
export default {
  name: 'EntityField',
  props: {
    updateSelection: { type: Function, required: true },
    entities: { type: Array, default: () => ['thing', 'stuff'] },
    useHolder: { type: Boolean, default: false },
    selection: String,
    errors: Array,
    required: Boolean
  },
  computed: {
    selected: {
      get() {
        return this.selection
      },
      set(value) {
        this.updateSelection(value)
      }
    }
  }
}
</script>

<i18n>
{
  "en": {
    "entity": "@:labels.entity"
  },
  "fr": {
    "entity": "@:labels.entity"
  }
}
</i18n>
